import { useLocationContext } from 'state/location';

const useIsFirstLocation = () => {
  const { location } = useLocationContext();
  // `key` will be 'default' for the first visited location of this site
  return location.key === 'default';
};

export default useIsFirstLocation;
